import React, { useState } from 'react';
import { LoadScript } from '@react-google-maps/api';
import GMap from "./GMap";
import './Contacts.css';
import {
    MapPin,
    Phone,
    Mail,
    Copy,
    Check,
    ArrowUpRight
} from 'lucide-react';

export default function Contacts() {
    const [copied, setCopied] = useState('');

    function getDirections() {
        window.open(
            "https://www.google.com/maps/dir//Tenafly+Prep+Academy,+Tenafly,+NJ/@40.9252068,-74.0358252,12z/data=!3m1!4b1!4m9!4m8!1m0!1m5!1m1!1s0x89c2f19653b04609:0x3adf23ab581d0cb7!2m2!1d-73.9657847!2d40.9250983!3e0",
            "_blank"
        );
    }

    async function copyToClipboard(text, type) {
        try {
            await navigator.clipboard.writeText(text);

            setCopied(type);

            // Return the button to its normal state after a short delay
            setTimeout(() => {
                setCopied('');
            }, 1600);
        } catch (error) {
            console.error('Failed to copy:', error);
        }
    }

    return (
        <div className="contacts-container">

            {/* Back to top */}
            <button
                className="back-to-top-button"
                onClick={() =>
                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                    })
                }
                aria-label="Back to top"
            >
                <img
                    src="scroll-up-arrow-white.svg"
                    alt=""
                    className="back-to-top-icon"
                />
            </button>

            <div className="contacts-content">
                <div className="contacts-heading">
                    <span className="heading-eyebrow">Get in touch</span>
                    <h1>Contact Us</h1>
                </div>

                <div className="contacts-wrapper">

                    {/* Google Map — intentionally left alone */}
                    <div className="map-container">
                        <LoadScriptOnlyIfNeeded
                            googleMapsApiKey={process.env.REACT_APP_GMAP_API_KEY}
                        >
                            <GMap />
                        </LoadScriptOnlyIfNeeded>
                    </div>

                    {/* Contact information */}
                    <div className="contact-info-panel">

                        {/* Address */}
                        <div className="contact-card">

                            <div className="contact-card-icon">
                                <MapPin size={19} strokeWidth={1.8} />
                            </div>

                            <div className="contact-card-content">
                                <span className="contact-label">Address</span>

                                <a
                                    href="https://www.google.com/maps/dir//Tenafly+Prep+Academy..."
                                    target="_blank"
                                    rel="noreferrer"
                                    className="contact-value contact-link"
                                >
                                    20 Washington Street,
                                    <span>Tenafly, NJ 07670</span>
                                </a>

                                <div className="card-actions">

                                    <button
                                        className={`icon-action ${copied === 'address' ? 'copied' : ''}`}
                                        onClick={() =>
                                            copyToClipboard(
                                                "20 Washington Street, Tenafly, NJ, 07670",
                                                'address'
                                            )
                                        }
                                    >
                                        {copied === 'address' ? (
                                            <>
                                                <Check size={14} />
                                                Copied
                                            </>
                                        ) : (
                                            <>
                                                <Copy size={14} />
                                                Copy
                                            </>
                                        )}
                                    </button>

                                    <button
                                        className="contacts-button"
                                        onClick={getDirections}
                                    >
                                        Directions
                                        <ArrowUpRight size={14} />
                                    </button>

                                </div>
                            </div>

                        </div>

                        {/* Phone */}
                        <div className="contact-card">

                            <div className="contact-card-icon">
                                <Phone size={19} strokeWidth={1.8} />
                            </div>

                            <div className="contact-card-content">
                                <span className="contact-label">Phone</span>

                                <a
                                    href="tel:201-390-2381"
                                    className="contact-value contact-link"
                                >
                                    (201) 390-2381
                                </a>

                                <div className="card-actions">

                                    <button
                                        className={`icon-action ${copied === 'phone' ? 'copied' : ''}`}
                                        onClick={() =>
                                            copyToClipboard(
                                                "201-390-2381",
                                                'phone'
                                            )
                                        }
                                    >
                                        {copied === 'phone' ? (
                                            <>
                                                <Check size={14} />
                                                Copied
                                            </>
                                        ) : (
                                            <>
                                                <Copy size={14} />
                                                Copy
                                            </>
                                        )}
                                    </button>

                                    <a
                                        href="tel:201-390-2381"
                                        className="contacts-button"
                                    >
                                        Call Now
                                    </a>

                                </div>
                            </div>

                        </div>

                        {/* Email */}
                        <div className="contact-card">

                            <div className="contact-card-icon">
                                <Mail size={19} strokeWidth={1.8} />
                            </div>

                            <div className="contact-card-content">
                                <span className="contact-label">Email</span>

                                <a
                                    href="mailto:tenaflyacademy26@gmail.com"
                                    className="contact-value contact-link email-value"
                                >
                                    tenaflyacademy26@gmail.com
                                </a>

                                <div className="card-actions">

                                    <button
                                        className={`icon-action ${copied === 'email' ? 'copied' : ''}`}
                                        onClick={() =>
                                            copyToClipboard(
                                                "tenaflyacademy26@gmail.com",
                                                'email'
                                            )
                                        }
                                    >
                                        {copied === 'email' ? (
                                            <>
                                                <Check size={14} />
                                                Copied
                                            </>
                                        ) : (
                                            <>
                                                <Copy size={14} />
                                                Copy
                                            </>
                                        )}
                                    </button>

                                    <a
                                        href="mailto:tenaflyacademy26@gmail.com"
                                        className="contacts-button"
                                    >
                                        Email Us
                                    </a>

                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}


class LoadScriptOnlyIfNeeded extends LoadScript {
    componentDidMount() {
        const cleaningUp = true;
        const isBrowser = typeof document !== "undefined";

        const isAlreadyLoaded =
            window.google &&
            window.google.maps &&
            document.querySelector('body.first-hit-completed');

        if (!isAlreadyLoaded && isBrowser) {
            if (window.google && !cleaningUp) {
                console.error("google api is already presented");
                return;
            }

            this.isCleaningUp().then(this.injectScript);
        }

        if (isAlreadyLoaded) {
            this.setState({ loaded: true });
        }
    }
}